import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { ADMIN_CONTENT_MAX_WIDTH } from './constants';

const styles = (theme) => ({
  root: {
    width: '100%',
    minWidth: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    /* Горизонтальные отступы задаёт App (styles.content); здесь только вертикальный ритм и maxWidth */
    paddingBottom: theme.spacing(1),
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    boxSizing: 'border-box',
  },
  beforeHeader: {
    marginBottom: theme.spacing(0.5),
  },
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  titleBlock: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  title: {
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.3,
    color: theme.palette.text.primary,
  },
  subtitle: {
    marginTop: theme.spacing(0.5),
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
  },
  actions: {
    flex: '0 0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  body: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
});

/**
 * Единая оболочка страницы админки: заголовок, подзаголовок, слот действий, предсказуемая ширина.
 */
function AdminPageShell(props) {
  const {
    classes,
    title,
    subtitle,
    actions,
    beforeHeader,
    children,
    maxWidth,
    'data-testid': dataTestId,
  } = props;

  const showHeader = title != null && title !== false;

  return (
    <div
      className={classes.root}
      style={{ maxWidth: maxWidth != null ? maxWidth : ADMIN_CONTENT_MAX_WIDTH }}
      data-testid={dataTestId}
    >
      {beforeHeader != null && beforeHeader !== false && (
        <div className={classes.beforeHeader}>{beforeHeader}</div>
      )}
      {showHeader && (
        <div className={classes.header}>
          <div className={classes.titleBlock}>
            {typeof title === 'string' || typeof title === 'number' ? (
              <Typography component="h1" className={classes.title}>
                {title}
              </Typography>
            ) : (
              title
            )}
            {subtitle != null && subtitle !== false && (
              typeof subtitle === 'string' || typeof subtitle === 'number' ? (
                <Typography component="p" className={classes.subtitle}>
                  {subtitle}
                </Typography>
              ) : (
                <div className={classes.subtitle}>{subtitle}</div>
              )
            )}
          </div>
          {actions != null && actions !== false && (
            <div className={classes.actions}>{actions}</div>
          )}
        </div>
      )}
      <div className={classes.body}>{children}</div>
    </div>
  );
}

AdminPageShell.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  beforeHeader: PropTypes.node,
  children: PropTypes.node,
  maxWidth: PropTypes.number,
  'data-testid': PropTypes.string,
};

AdminPageShell.defaultProps = {
  title: null,
  subtitle: null,
  actions: null,
  beforeHeader: null,
  children: null,
  maxWidth: null,
  'data-testid': undefined,
};

export default withStyles(styles)(AdminPageShell);
